const template = require('./playlistView.template');

export const PlaylistViewComponent = {
    template,
    controller: PlaylistView,
    controllerAs: 'vm',
    bindings: {
        context: '<',
        state: '<',
        featurePlaylist: '<'
    }
}

/**
 * @ngdoc directive
 * @name sharebase.playlistView:sbPlaylistView
 * @module sharebase.playlistView
 * @restrict e
 * @description
 * `sbPlaylistView` Displays YouTube playlists contents
 *
 * @usage
 *
 * <sb-playlist-view context="admin.usergroups" /> 
 * 
 * @element input
 * @param {string=} context The view or type of content currently being viewed.
 */
export function PlaylistView($sce, gettextCatalog) {
    var vm = this;
    vm.playlists = [];
    vm.recomendedPlaylists = [];
    vm.playlistsRaw = [
        {
            title: gettextCatalog.getString('Getting Started'),
            playlistId:'',
            playlists: {
                en: 'PL1P_sExxi-9OVJtuooIhhTgVHcQ_MSLNz',
                es: 'PL1P_sExxi-9PCmtebEYy23VXRN7-ivm6X'
            },
            context: 'app',
            screens: ['home'],
            tags:['home', 'introduction', '101']
        }, 
        {
            title: gettextCatalog.getString('Using the ShareBase Desktop'),
            playlistId:'',
            playlists: {
                en: 'PL1P_sExxi-9Nrok1H0O4STvlVCOyOrOYh',
                es: 'PL1P_sExxi-9PBqBwxeNMqMrwE_rsyvjMQ'
            },
            context: 'app',
            screens: [],
            tags:['desktop']
        },  
        {
            title: gettextCatalog.getString('Using the ShareBase Mobile'),
            playlistId:'',
            playlists: {
                en: 'PL1P_sExxi-9NHJyY_-GJcmHNA2jp67y3Q',
                es: 'PL1P_sExxi-9M-bJKSGUrscjHuA3mcRvm7'
            },
            context: 'app',
            screens: [],
            tags:['desktop']
        }, 
        {
            title: gettextCatalog.getString('New Features'),
            playlistId: '',
            playlists: {
                en: 'PL1P_sExxi-9Od0_fGMl3KQioR4H6ATf8i',
                es: 'PL1P_sExxi-9NDAJSR-wv7O0sHJbfhzBxw'
            },
            context: 'app',
            screens: ['home'],
            tags: ['home'],
            isFeature: true
        }
    ];

    vm.recommendedHeading = '';

    vm.buildTrustedURL = function(id){
        return $sce.trustAsResourceUrl('https://www.youtube.com/embed/videoseries?list=' + id );
    };

    this.$onChanges = function(changes){
        if (changes.featurePlaylist.currentValue) {
            vm.playlists = [];
            vm.recomendedPlaylists = vm.playlistsRaw.filter(function(playlist) {
                return playlist.isFeature;
            })
            .map(addPlaylistId);
            vm.playlists = [];
        }
        else if(changes.context){
            if(changes.context.currentValue){
                
                vm.playlists = vm.playlistsRaw
                    .filter(function(playlist) { return !playlist.isFeature; })
                    .filter(function(playlist){
                        var screens = playlist.screens.filter(function(screen){
                            return vm.state.indexOf(screen) > -1;
                        });
                        return (playlist.context === vm.context && screens.length === 0);
                    })
                    .map(addPlaylistId);

                vm.recomendedPlaylists = vm.playlistsRaw
                    .filter(function(playlist) { return !playlist.isFeature; })
                    .filter(function(playlist){
                        
                        var screens = playlist.screens.filter(function(screen){
                            return vm.state.indexOf(screen) > -1;
                        });

                        return (playlist.context === vm.context && screens.length > 0);
                    })
                    .map(addPlaylistId);
            }
        }
    };

    var lang = gettextCatalog.getCurrentLanguage();
    function addPlaylistId(playlist) {
        var plId = playlist.playlists[lang];
        if (!angular.isDefined(plId)) {
            plId = playlist.playlists['en'];
        }

        playlist.playlistId = plId;
        return playlist;
    }
}

PlaylistView.$inject = [ 
    '$sce', 
    'gettextCatalog'
];



// WEBPACK FOOTER //
// ./src/sharebase/components/playlistView/playlistView.component.ts